
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Callout,
  Category,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Callout`}</h1>
<p>{`Component used to display a message that complements the content of the page. Similar to `}<a parentName="p" {...{
        "href": "/component-kit/components/banner"
      }}><inlineCode parentName="a">{`Banner`}</inlineCode></a>{`, but used to the give the user more in depth information about what they're seeing on the page, sort of like tips. Cannot be dismissed.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Callout } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Callout category={Category.SUCCESS}>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
</Callout>`} component={Callout} mdxType="Playground">
  <Callout category={Category.SUCCESS} mdxType="Callout">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
  </Callout>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;